import React from "react";
import Slider from '../inc/Slider';
import fruits from '../img/PngItem_1215353.png';
import orange from '../img/icons8-orange-100.png';
import banana from '../img/icons8-banana-100.png';
import anar from '../img/icons8-pomegranate-100.png';
import About from '../inc/About';
import Review from '../inc/Review';
import Banner from '../inc/Banner';

function Home(){
    return(<>
          <Slider/>
          <div class="sec1">
            <div class="container col-xxl-8 px-4 py-5">
                <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
                <div class="col-10 col-sm-8 col-lg-6" >
                    <img src={fruits} class="d-block mx-auto img-fluid flicker-1"   loading="lazy" />
                </div>
                <div class="col-lg-6">
                    <h1 class="display-5 fw-bold  bg_text lh-1 mb-3">We Sell The Best Fruits!</h1>
                    <div class="fancy-border"></div>
                    <p class="lead text-muted p-3">In common language usage, "fruit" normally means the fleshy seed-associated structures of a plant that are sweet or sour, and edible in the raw state</p>
                    <div class=" text-center">
                    <button to="/about" type="button" class="btn-bg btn-lg px-4 me-md-2">View More </button>
                    
                    </div>
                </div>
                </div>
            </div>
          </div>


                 <div id="sec2">
                    
                    <div class="container px-4 py-5" id="custom-cards">
                         
                    <div className="row mb-2">
                    <div className="about_title">
                    <p className="fw-bold">DISCOUNT</p>
                        <h3 className="fw-bold bg_text">On Going Offers</h3>
                        <div class="fancy-border"></div>
                    </div>
                    </div>

                <div class="row row-cols-1 row-cols-lg-3 align-items-stretch g-4 py-5">
                <div class="col scale-in-top ">
                    <div class="card card-cover h-100 overflow-hidden  rounded-4 shadow-lg box " >
                    <div class="d-flex flex-column h-100 p-5 pb-3 text-shadow-1 ">
                    <li class="mx-auto mb-0 pb-0 list">
                         <img src={orange}  width="50" height="50" />
                         <p className="bg_text fw-bold hurry"><small>HURRY UP</small></p>
                        </li>
                        <h3 class="pt-5 mt-5 mb-4 display-6 lh-1 text-white fs-3 fw-bold">Fresh Orange Fruits !</h3>
                        <div class="fancy-border"></div>
                        <p className=" bg_text  fw-bold mt-3 mb-3 pt-3">Up to 40% OFF!</p>
                        <div class=" text-center">
                    <button to="/about" type="button" class="btn-bg btn-lg px-4 me-md-2">View More </button>
                      </div>
                       
                    </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card card-cover h-100 overflow-hidden rounded-4 shadow-lg box1" >
                    <div class="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1">
                         <li class="mx-auto mb-0 pb-0  list">
                            <img src={anar}  width="50" height="50" class="" />
                            <p className="bg_text fw-bold hurry"><small>HURRY UP</small></p>
                        </li>
                        <h3 class="pt-5 mt-5 mb-4 display-6 text-white fs-3 fw-bold"> Fresh Pomegranate</h3>
                        <div class="fancy-border"></div>
                        <p className="bg_text fw-bold mt-3 pt-3">Up to 30% OFF!</p>
                        <ul class="d-flex list-unstyled mx-auto">
                        <div class=" text-center">
                    <button to="/about" type="button" class="btn-bg btn-lg px-4 me-md-2">View More </button>
                      </div>
                        
                        </ul>
                    </div>
                    </div>
                </div>

                <div class="col scale-in-ver-bottom">
                    <div class="card card-cover h-100 overflow-hidden rounded-4 shadow-lg box2" >
                    <div class="d-flex flex-column h-100 p-5 pb-3 text-shadow-1">
                         <li class="mx-auto mb-0 pb-0 list">
                            <img src={banana}  width="50" height="50" class="" />
                            <p className="bg_text fw-bold hurry"><small>HURRY UP</small></p>
                        </li>
                        <h3 class="pt-5 mt-5 display-6 lh-1 text-white  fw-bold">Fresh Banana!</h3>
                        <div class="fancy-border"></div>
                        <p className="bg_text fw-bold mt-3 pt-3">Up to 29% OFF!</p>
                        
                        <ul class="d-flex list-unstyled mx-auto">
                        <div class=" text-center">
                    <button to="/about" type="button" class="btn-bg btn-lg px-4 me-md-2">View More </button>
                      </div>
                       
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div> 

        <Banner/>
        <About/>
   
        <div className="container mb-5 mt-5 pb-5 pt-5 ">
        <div className="row mb-2 mt-5">
            <div className="about_title">
                <p className="fw-bold">BENEFITS</p>
                <h3 className="fw-bold bg_text">Why Choose Us</h3>
                <div class="fancy-border"></div>
            </div>
            </div>
            <div className="row mt-5">
                <div className="col-lg-4">
                <div class="col d-flex align-items-start">
                    <div class="icon-square text-body-emphasis d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3">
                    <i class="bi bi-check2-circle bg p-1 text-white rounded-circle"></i>
                    </div>
                    <div>
                    <h3 class="fs-4 text-body-emphasis text-start">Fresh is Best</h3>
                    <div class="fancy-border_left"></div>
                    <p className="text-muted p-2 text-start">Fresh is Best 100% fresh fruits delivery guaranteed! We inspect every package prior to shipping.</p>
                   
                    </div>
                </div>
                <div class="col d-flex align-items-start">
                    <div class="icon-square text-body-emphasis d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3">
                    <i class="bi bi-check2-circle bg p-1 text-white rounded-circle"></i>
                    </div>
                    <div>
                    <h3 class="fs-4 text-body-emphasis text-start">Nature's Bounty Market </h3>
                    <div class="fancy-border_left"></div>
                    <p className="text-muted p-2 text-start">Experience nature's best at our market – a vibrant selection of fresh, seasonal fruits awaits you.</p>
                   
                    </div>
                </div>

                <div class="col d-flex align-items-start">
                    <div class="icon-square text-body-emphasis d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3">
                    <i class="bi bi-check2-circle p-1 bg text-white rounded-circle"></i>
                    </div>
                    <div>
                    <h3 class="fs-4 text-body-emphasis text-start">The Benefits Only </h3>
                    <div class="fancy-border_left"></div>
                    <p className="text-muted p-2 text-start">We make sure that our regular clients get as many benefits as possible, on all orders.</p>
                   
                    </div>
                </div>
                </div>
                <div className="col-lg-4 mb-3 mt-3">
                    <img className="rotate-center" src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/icon_services.png"/>
                </div>
                <div className="col-lg-4">
                <div class="col d-flex align-items-start">
                    <div class="icon-square text-body-emphasis d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3">
                    <i class="bi bi-check2-circle bg p-1 text-white rounded-circle"></i>
                    </div>
                    <div>
                    <h3 class="fs-4 text-body-emphasis text-start">Green Grove Fruits</h3>
                    <div class="fancy-border_left"></div>
                    <p className="text-muted p-2 text-start">Visit Green Grove Fruits for fresh, wholesome produce – a celebration of nature's abundance in every bite.</p>
                   
                    </div>
                </div>
                <div class="col d-flex align-items-start">
                    <div class="icon-square text-body-emphasis d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3">
                    <i class="bi bi-check2-circle bg p-1 text-white rounded-circle"></i>
                    </div>
                    <div>
                    <h3 class="fs-4 text-body-emphasis text-start">Fruity Delights Corner</h3>
                    <div class="fancy-border_left"></div>
                    <p className="text-muted p-2 text-start">indulge in juicy delights at our corner – where health and flavor meet in every bite.</p>
                   
                    </div>
                </div>

                <div class="col d-flex align-items-start">
                    <div class="icon-square text-body-emphasis d-inline-flex align-items-center justify-content-center fs-4 flex-shrink-0 me-3">
                    <i class="bi bi-check2-circle bg p-1 text-white rounded-circle"></i>
                    </div>
                    <div>
                    <h3 class="fs-4 text-body-emphasis text-start">Sustainable Practice </h3>
                    <div class="fancy-border_left"></div>
                    <p className="text-muted p-2 text-start">The reuse of materials is a sustainable practice that is rapidly growing among farmers.</p>
                   
                    </div>
                </div>

                
                </div>

            </div>

        </div>

        <div className="container mb-5">
        <Review/>
        </div>

    </>
       
       
    
    );
}
export default Home;